/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FileUploadDocumentResponseDataFromJSON, FileUploadDocumentResponseDataToJSON } from './FileUploadDocumentResponseData';
export function FileUploadDocumentResponseFromJSON(json) {
    return FileUploadDocumentResponseFromJSONTyped(json, false);
}
export function FileUploadDocumentResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: json['status'],
        data: FileUploadDocumentResponseDataFromJSON(json['data'])
    };
}
export function FileUploadDocumentResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: FileUploadDocumentResponseDataToJSON(value.data)
    };
}
